import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { RUN_MODELS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { RunModelsDataActionTypes } from './types';
import modelsApi from 'src/utils/api/modelsApi';
import { runModelsTime } from '../allModels/actions';

export const loadRunModels =
  (
    id: string,
  ): ThunkAction<Promise<void>, State, null, RunModelsDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: RUN_MODELS + REQUEST });
    try {
      const payload = await modelsApi.loadRunModels(id);
      dispatch(runModelsTime(id));
      dispatch({ type: RUN_MODELS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: RUN_MODELS + FAILURE, error });
    }
  };

export const runModelsIdle = () => ({ type: RUN_MODELS + IDLE });
